export const addressMessages = {
  'address.add': 'Add address',
  'address.addSuccess': 'Address added',
  'address.addTitle': 'New address',
  'address.default': 'Default',
  'address.deleteConfirm': 'Delete this address?',
  'address.deleteFail': 'Delete failed',
  'address.deleteSuccess': 'Address deleted',
  'address.deleteTitle': 'Delete address',
  'address.editTitle': 'Edit address',
  'address.empty': 'No addresses yet',
  'address.formIncomplete': 'Please fill in all fields',
  'address.label.city': 'City',
  'address.label.detail': 'Detail',
  'address.label.district': 'District',
  'address.label.phone': 'Phone',
  'address.label.province': 'Province',
  'address.label.recipient': 'Recipient',
  'address.ph.city': 'City',
  'address.ph.detail': 'Street, building, etc.',
  'address.ph.district': 'District',
  'address.ph.phone': 'Phone number',
  'address.ph.province': 'Province',
  'address.ph.recipient': 'Recipient name',
  'address.saveFail': 'Save failed',
  'address.setDefault': 'Set as default',
  'address.setDefaultFail': 'Failed to set default',
  'address.setDefaultSuccess': 'Default address updated',
  'address.title': 'Shipping addresses',
  'address.updateSuccess': 'Address updated',
};
